import { type ReactNode, useCallback, useMemo, useRef, useState } from 'react';
import { analytics } from 'libs';
import { SavedFilterContext } from 'components/filters';

interface ContextProps {
  children: ReactNode;
}

const Context = ({ children }: ContextProps) => {
  const [savedFilterPanelOpen, setSavedFilterPanelOpen] = useState(false);

  const buttonAsideRef = useRef(null);
  const buttonTopRef = useRef(null);

  const onClose = useCallback(() => {
    if (!savedFilterPanelOpen) return;
    setSavedFilterPanelOpen(false);
    analytics.productSearch.savedFilters.close();
  }, [savedFilterPanelOpen]);

  const handleToggle = useCallback(
    (location: 'aside' | 'topbar') => {
      if (savedFilterPanelOpen) {
        onClose();
      } else {
        setSavedFilterPanelOpen(true);
        analytics.productSearch.savedFilters.open(location);
      }
    },
    [onClose, savedFilterPanelOpen]
  );

  const contextValue = useMemo(
    () => ({
      buttonAsideRef,
      buttonTopRef,
      handleToggle,
      onClose,
      savedFilterPanelOpen,
    }),
    [handleToggle, onClose, savedFilterPanelOpen]
  );

  return (
    <SavedFilterContext.Provider value={contextValue as any}>
      <div id="context" className="container-fluid with-sidebar context">
        {children}
      </div>
    </SavedFilterContext.Provider>
  );
};

export default Context;
